import styled from 'styled-components';

export const Asterix = styled.span`
  color: ${({ theme }) => theme.danger.background};
  margin-left: 4px;
`;
